import { Injectable } from '@angular/core';
import { NavaidDTOCalculation, NavaidModel } from '../models/navaid';
import { RemoveGroundStationsDTO, isToRemoveFromDLL } from '../models/RemoveGroundStationsDTO';
import { ProjectService } from './project.service';
import { EndpointsService } from './endpoints.service';
import { HttpClient, HttpParams} from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { UiBlockService } from './ui-block.service';

@Injectable({
  providedIn: 'root'
})
export class GroundStationsService {

  constructor(
    private readonly projectService: ProjectService,
    private readonly endpointService: EndpointsService,
    private readonly http: HttpClient,
    private readonly uiBlock: UiBlockService,
  ) { }


  public removeGroundStations(newNavaids: NavaidModel[], oldNavaids: NavaidModel[], waitForCompletion: boolean = false) {
    if (!newNavaids || !oldNavaids) {
      return;
    }

    const newNavaidsMap: Map<string, NavaidModel> = new Map(newNavaids.map(navaid => [navaid.id, navaid]));

    const filteredOldNavaids: NavaidModel[] = oldNavaids.filter(oldNavaid => newNavaidsMap.has(oldNavaid.id));

    const toBeRemovedGS: NavaidModel[] = [];

    filteredOldNavaids.forEach(oldNavaid => {
      const newNavaid = newNavaidsMap.get(oldNavaid.id);
      if (newNavaid) {
        if (isToRemoveFromDLL(oldNavaid, newNavaid)) {
          toBeRemovedGS.push(oldNavaid);
        }
      }
    });

    if (toBeRemovedGS.length == 0) {
      return;
    }

    this.removeGroundStationsRequest(toBeRemovedGS, waitForCompletion);
  }


  public removeGroundStationsRequest(toBeRemovedGS: NavaidModel[], waitForCompletion: boolean = false) {
    if (!toBeRemovedGS) {
      return;
    }

    const options = waitForCompletion
      ? { ...this.endpointService.httpOptions, params: new HttpParams().set('waitForCompletion', 'true') }
      : this.endpointService.httpOptions;

    this.http
      .post(
        this.endpointService.removeGroundStations,
        new RemoveGroundStationsDTO(toBeRemovedGS.map(n => this.transformNavaid(n)), this.projectService.activeProject.id),
        options
      ).subscribe();
  }

  public async removeGroundStationsRequestPromise(toBeRemovedGS: NavaidModel[]) {
    if (!Array.isArray(toBeRemovedGS) || toBeRemovedGS.length === 0) {
        return;
      }
    this.uiBlock.startBlock("Preparing Calculation...");
    await firstValueFrom(this.http
      .post(
        this.endpointService.removeGroundStations,
        new RemoveGroundStationsDTO(toBeRemovedGS.map(n => this.transformNavaid(n)), this.projectService.activeProject.id),
        this.endpointService.httpOptions
    ));

    this.uiBlock.stopBlock();
  }

  private transformNavaid(
    navaid: NavaidModel
  ): NavaidDTOCalculation {
    let model: NavaidDTOCalculation = new NavaidDTOCalculation();
    model.id = navaid.navaidid;
    model.type = navaid.navaidtype;
    model.uniqueId =
      navaid.navaidid +
      '_' +
      navaid.icaocc +
      '_' +
      navaid.navaidtype;

    return model;
  }
}
